'use client';

import { useEffect } from 'react';

/**
 * Client Component for browser polyfill loading
 * Detects Safari and loads focus-visible polyfill
 */
export default function BrowserPolyfills() {
  useEffect(() => {
    const isSafari = /safari|ios/i.test(navigator.userAgent);
    if (isSafari) import('focus-visible');
  }, []);

  return null;
}
